import { render, staticRenderFns } from "./vc-col.vue?vue&type=template&id=65d8818d&"
import script from "./vc-col.vue?vue&type=script&lang=js&"
export * from "./vc-col.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports